module.exports = __webpack_public_path__ + "img/tool-youtube.34b251c.webp";